document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll(
    '.media-gallery--hover-zoom .product-media-container--image'
  );

  const ZOOM_FACTOR = 2.5;

  containers.forEach((container) => {
    const img = container.querySelector('img');
    if (!img) return;

    const lens = document.createElement('div');
    lens.className = 'hover-magnify-pane';
    container.appendChild(lens);

    function handleMove(event) {
      const rect = container.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        lens.classList.remove('is-visible');
        return;
      }

      lens.style.left = `${x}px`;
      lens.style.top = `${y}px`;

      const src = img.currentSrc || img.src;
      lens.style.backgroundImage = `url(${src})`;
      lens.style.backgroundSize = `${rect.width * ZOOM_FACTOR}px ${rect.height * ZOOM_FACTOR}px`;

      const relX = x / rect.width;
      const relY = y / rect.height;
      const bgPosX = relX * 100;
      const bgPosY = relY * 100;
      lens.style.backgroundPosition = `${bgPosX}% ${bgPosY}%`;

      lens.classList.add('is-visible');
    }

    container.addEventListener('mousemove', handleMove);
    container.addEventListener('mouseleave', () => {
      lens.classList.remove('is-visible');
    });
  });
});